// NEW APP TODO – Replace with the appropriate links for your application.
export const EXTERNAL_LINKS = {
  TERMS:
    'https://www.geisinger.org/about-geisinger/corporate/corporate-policies/terms-of-use',
  PRIVACY:
    'https://www.geisinger.org/about-geisinger/corporate/corporate-policies/website-privacy-policy',
  DISCLAIMER: 'https://google.com/disclaimer',
  APPLE_STORE_APP: 'https://apple.com',
  GOOGLE_PLAY_STORE_APP: 'https://google.com',
};
